import './reset_password.css';
import { useEffect, useRef, useState } from 'react';
import { BarLoader } from '../BarLoader/BarLoader';
import { LoginScreen, useLogin } from '../../pages/login/LoginContext';
import { useServer } from '../../context/ServerContext';
import { endpoints } from '../../env';

export const ResetPassword = () => {
    //HOOKS
    const { 
        ActiveScreen,
        setActiveScreen,
        recoverCode,
    } = useLogin();

    const {
        postRequest
    } = useServer();

    //REFS
    const formRef = useRef();

    //STATES
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    //FUNCTIONS
    const postRecover = () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setErrorMsg("");

        if (password !== repeatPassword || password === "") {
            setLoading(false);
            setErrorMsg("Password must match");
            return;
        }

        const data = {
            code: recoverCode,
            password,
        }

        postRequest(endpoints.recover_password, data, (res) => {
            setLoading(false);
            if (res[0]) {
                res = res[1];
                if (res.success) {
                    setActiveScreen(LoginScreen.LOGIN);
                } else {
                    setErrorMsg("Server error, please try again in a bit.");
                }
            } else {
                setErrorMsg("Server error, please try again in a bit.");
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        if (ActiveScreen === LoginScreen.PASSWORD_RESET) {
            formRef.current.classList.add('active');
        } else {
            formRef.current.classList.remove('active');
        }
    }, [ActiveScreen]);

    return (
        <div className='reset_password_form' ref={formRef}>
            <button className='close' onClick={() => setActiveScreen(LoginScreen.MAIN_SCREEN)}>
                <i className="fa-solid fa-chevron-down"></i>
            </button>
            <h2 className="title">
                Reset password
            </h2>
            <span className='subtitle'>Enter the new password</span>
            <div className='form'>
                <div className='input_group'>
                    <label>New password</label>
                    <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div className='input_group'>
                    <label>Repeat password</label>
                    <input type='password' value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)} />
                </div>
                {
                    errorMsg !== "" && (
                        <span className='error_msg'>
                            {errorMsg}
                        </span>
                    )
                }
                {
                    loading && (
                        <div className='loader'>
                            <BarLoader />
                        </div>
                    )
                }   
                <button disabled={loading} onClick={postRecover}>
                    Save new password
                </button>
            </div>
        </div>
    );
};